/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramStaticPagesControllerFindOneByTypeQueryResponse,
  TelegramStaticPagesControllerFindOneByTypePathParams,
} from '../../types/TelegramStaticPagesControllerFindOneByType.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramStaticPagesFindOneByType } from '../../methods/telegramStaticPagesFindOneByType.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramStaticPagesFindOneByTypeQueryKey = (
  type: TelegramStaticPagesControllerFindOneByTypePathParams['type'],
) => [{ url: '/api/telegram/static-pages/:type', params: { type: type } }] as const;

export type TelegramStaticPagesFindOneByTypeQueryKey = ReturnType<typeof telegramStaticPagesFindOneByTypeQueryKey>;

export function telegramStaticPagesFindOneByTypeQueryOptions(
  type: TelegramStaticPagesControllerFindOneByTypePathParams['type'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramStaticPagesFindOneByTypeQueryKey(type);
  return queryOptions<
    TelegramStaticPagesControllerFindOneByTypeQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramStaticPagesControllerFindOneByTypeQueryResponse,
    typeof queryKey
  >({
    enabled: !!type,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramStaticPagesFindOneByType(type, config);
    },
  });
}

/**
 * {@link /api/telegram/static-pages/:type}
 */
export function useTelegramStaticPagesFindOneByType<
  TData = TelegramStaticPagesControllerFindOneByTypeQueryResponse,
  TQueryData = TelegramStaticPagesControllerFindOneByTypeQueryResponse,
  TQueryKey extends QueryKey = TelegramStaticPagesFindOneByTypeQueryKey,
>(
  type: TelegramStaticPagesControllerFindOneByTypePathParams['type'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramStaticPagesControllerFindOneByTypeQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramStaticPagesFindOneByTypeQueryKey(type);

  const query = useQuery(
    {
      ...telegramStaticPagesFindOneByTypeQueryOptions(type, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
